import React from 'react';
import { Box, Flex, Skeleton } from '@chakra-ui/react';

const CareHomePageSkeleton: React.FC = () => {
  return (
    <Box>
      <Box width="40%" mb="10px" height="75px" display="flex" alignItems="center" p={"25px"} borderRadius="20px">
        <Skeleton flex="1" height="20px" startColor="#c0c0c0" endColor="#e0e0e0" />
      </Box>

      <Box bg="white" p="50px" borderRadius="20px">
        <Flex direction="column">
          <Box>
            <Skeleton height="30px" width="50%" />
          </Box>

          <Box>
            <Skeleton height="20px" mt="4" width="25%" />
            <Skeleton height="20px" mt="1" width="40%" />
          </Box>

          <Box>
            <Skeleton height="20px" mt="4" width="25%" />
            <Skeleton height="20px" mt="1" width="40%" />
          </Box>

          <Box>
            <Skeleton height="20px" mt="4" width="25%" />
            <Skeleton height="20px" mt="1" width="40%" />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default CareHomePageSkeleton;